export const UPDATE_TIMEZONE = 'UPDATE_TIMEZONE';
export const UPDATE_LOADING_STATE = 'UPDATE_LOADING_STATE';
export const TOGGLE_DARK_THEME_MODE = 'TOGGLE_DARK_THEME_MODE';
